import Vue from 'vue';
import dateOnly from '@/filters/dateOnly';
import formatDate from '@/filters/formatDate';
import formatDates from '@/filters/formatDates';
import startCase from '@/filters/startCase';
import formatPrice from '@/filters/formatPrice';
import truncate from '@/filters/truncate';
import joinTable from '@/filters/joinTable';
import rawText from '@/filters/rawText';
import terminal from '@/filters/terminal';
import productVariants from '@/filters/productVariants';

Vue.filter('dateOnly', dateOnly);
Vue.filter('formatDate', formatDate);
Vue.filter('formatDates', formatDates);
Vue.filter('startCase', startCase);
Vue.filter('formatPrice', formatPrice);
Vue.filter('truncate', truncate);
Vue.filter('joinTable', joinTable);
Vue.filter('rawText', rawText);
Vue.filter('terminal', terminal);
Vue.filter('productVariants', productVariants);
